var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mq-layout',{attrs:{"mq":"tablet"}},[_c('div',{staticClass:"w-50 mx-auto"},[_c('vehicleForm')],1)]),_c('mq-layout',{attrs:{"mq":"laptop+"}},[_c('div',{staticClass:"w-100 mx-auto"},[_c('vehicleForm')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }